<template>
  <div>
    <p class="text-center mt-20">
      <b>안전대책 입력</b>
    </p>
    <p class="text-center text-666 mt-10">
      작업 단위별 안전대책을 입력하세요.
    </p>
    <div class="box mt-20">
      <div class="box-header text-right text-888 pv-6">
        <span class="ess ex"></span>필수 입력 사항입니다.
      </div>
      <div class="box-body">
        <textarea class="form-control" rows="6" v-model="localValue" placeholder="안전대책을 입력하세요."></textarea>
      </div>
    </div>
    <div class="btn-wrap justify-content-center mt-30 mb-40">
      <button class="btn btn-lg line-2" data-dismiss="modal" aria-label="Close" @click="cancel">
        <i class="icon-close mr-5"></i>취소</button>
      <button class="btn btn-lg success" data-dismiss="modal" aria-label="Close" @click="apply">
        <i class="icon-check mr-5"></i>적용</button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: () => ''
    },
    onConfirm: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      localValue: this.value
    };
  },
  methods: {
    apply() {
      if (this.onConfirm) {
        this.onConfirm(this.localValue);
      }
      this.$emit('close');
    },
    cancel() {
      this.$emit('close');
    }
  }
}
</script>

<style scoped>

</style>
